import React, { useEffect, useState } from "react";
import Headar from "../Component/Headar";
import BradCrum from "../Component/BradCrum";
import ShapeImg from "../aseets/img/curve.png";
import Footer from "../Component/Footer";
import MobileHader from "../Component/MobileHader";
import PlatinumFamily from "../Component/PlatinumFamily";
import WhyChusUS from "../Component/WhyChusUS";
import MemberShip from "../Page/MemberShip";
import MemberShipBanner from "../aseets/img/platinumMemberShipBanner.png";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { InfinitySpin } from "react-loader-spinner";

const MembershipPage = () => {
  const memberData = [
    {
      title: "Step 1",
      subTitle: "Welcome to the Platinum Club",
      description:
        "Your journey begins with a warm welcome to our exclusive circle. Whether you reach out online or prefer a personal call, we’re here to create a membership experience as unique as you. By learning about your likes, dislikes, and values, we tailor our approach to uncover the kind of person you naturally attract. With empathy and care, we ensure you feel right at home from the start.",
    },
    {
      title: "Step 2",
      subTitle: "Tailored Profile Matching",
      description:
        "This is where the magic begins. Our matchmaking experts curate profiles based on your preferences, aligning compatibility and values to create meaningful introductions. Each match is handpicked, ensuring you meet individuals who truly resonate with your personality and goals. From tailored opportunities to coordinated meetings, we’re by your side at every step to make the experience effortless and enjoyable.",
    },
    {
      title: "Step 3",
      subTitle: "Fostering Meaningful Connections",
      description:
        "Our aim is to rekindle the excitement and anticipation of meeting someone truly exceptional. As you connect with individuals who share your values and perspective on life, we’re here to guide you with enthusiasm and commitment. After each introduction, we’ll follow up with you, gathering feedback to continually fine-tune and perfect your journey. Your joy is our greatest accomplishment, and we’re dedicated to helping you find that extraordinary person – ‘the one’ who brings everything together seamlessly.",
    },
  ];
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`
        );
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 3
        ) {
          setBannerImages(response.data, "===>");
        }
      } catch (error) {
        console.error("Error fetching banner images:", error);
      }
    };

    fetchBannerImages();
  }, []);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
      // Simulate a delay of 2 seconds (adjust as needed)
      const delay = 1000;
      setTimeout(() => {
        setIsLoading(false);
      }, delay);
    }, []);
  return (
    <React.Fragment>
           {isLoading ? (
                // Loader component while loading
                <div className="loader-container">
                  <InfinitySpin
                    color="#000"
                    height={50}
                    width="200"
                    timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
                  />
                </div>
              ) : (
      <div>

   
      <Headar />
      <MobileHader />
      <BradCrum
        Title={bannerImages[3]?.Title}
        ShapeImg={ShapeImg}
        BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[3]?.bannerImage}`}
        color="#000"
      />
      <div className="aboutContainer container  newaboutcont">
        <div className="aboutSectionMainDiv membsrshipContainer">
                <div className="bannerTitle memberMainTitle"
                >
                  Welcome to Platinum Matches: Your Journey to Finding
                  <br />
                  "The One"
          </div>
          <br />
          <br />
          <div className="aboutPera founderDescription ">
            At Platinum Matches, we are transforming the matchmaking experience
            by combining timeless traditions with cutting-edge strategies. Our
            boutique service is designed to focus on what truly matters —
            genuine compatibility and meaningful connections.
          </div>
          <br />
          <div className="aboutPera founderDescription ">
            By aligning values, aspirations, and lifestyles, we help you
            discover relationships that are not only lasting but deeply
            fulfilling. Let us guide you on a journey to find a partner who
            resonates with your heart and soul.
          </div>
        </div>
      </div>

      {/* //// matchis steps =====>  */}
      <Container>
        <div className="matchesStepTitle">
          Tap Into Our Exclusive Matchmaking Network
        </div>
        <Row className="membershipRow">
          {memberData?.map((data) => (
            <Col className="membershipCol" lg={4} md={6}>
              <Card className="stepesCard">
                <div className="stepTitleDiv">
                  <div className="stepTitle">{data.title}</div>
                  <div className="stepSubTitle">{data.subTitle}</div>
                </div>
                <div className="stepDescription">{data.description}</div>
              </Card>
            </Col>
          ))}
       
        </Row>
      </Container>

      {/* ////// membershipe =====> */}
      {/* <MemberShip /> */}
      {/* /// meber ship form section ===>  */}
      <MemberShip />
      {/* <WhyChusUS />
      <PlatinumFamily /> */}
      <Footer />
      </div>
       )}
    </React.Fragment>
  );
};

export default MembershipPage;
